import {Inject, Injectable} from '@angular/core';
import {Company, COMPANY_SERVICE, CompanyService} from "@livechat/shared";
import {AnswerTemplateDto} from "../domain/dtos";
import {CreateAnswerTemplateUseCase} from "../../../domain/use-cases/create-answer-template-use.case";
import {answerTemplateDtoToAggregate} from "../domain/utils";
import {Nullable} from "@livechat/shared";
import {UpdateAnswerTemplateUseCase} from "../../../domain/use-cases/update-answer-template-use.case";
import {formValueToDto} from "../adapters/form.adapter";

export type AnswerTemplateForm = Nullable<Omit<AnswerTemplateDto, 'selected'>>;

@Injectable({
  providedIn: 'root'
})
export class AnswerTemplateManageModalFacade {

  constructor(
    @Inject(CreateAnswerTemplateUseCase) private createAnswerTemplate: CreateAnswerTemplateUseCase,
    @Inject(UpdateAnswerTemplateUseCase) private updateAnswerTemplate: UpdateAnswerTemplateUseCase,
    @Inject(COMPANY_SERVICE) private companyService: CompanyService,
  ) { }

  public getCompanies(): Array<Company> {
    return this.companyService.getCompanies() || [];
  }

  private getTemplateAggregate(template: AnswerTemplateDto) {
    const adaptedDto = formValueToDto(template);

    return answerTemplateDtoToAggregate(adaptedDto);
  }

  public save(template: AnswerTemplateDto) {
    return this.createAnswerTemplate.execute(this.getTemplateAggregate(template));
  }

  public update(template: AnswerTemplateDto) {
    return this.updateAnswerTemplate.execute(this.getTemplateAggregate(template));
  }

}
